import { Stack, Typography } from '@mui/material';

import { FBoxContainer } from '../../../../../components/baseV2';
import {
  TREATMENT_PLAN_V3_PAGE_BOX_SX,
  TREATMENT_PLAN_V3_PAGE_HEADING_INSET_SX,
  TREATMENT_PLAN_V3_SECTION_HEADING_SX,
} from '../../../styles';

import type { TreatmentPlanV3PageContentProps } from './types';

export default function TreatmentPlanV3PageContent({
  title,
  children,
}: TreatmentPlanV3PageContentProps) {
  return (
    <Stack gap={3}>
      <Typography
        variant="h5"
        sx={[TREATMENT_PLAN_V3_SECTION_HEADING_SX, TREATMENT_PLAN_V3_PAGE_HEADING_INSET_SX]}
      >
        {title}
      </Typography>
      <FBoxContainer sx={TREATMENT_PLAN_V3_PAGE_BOX_SX}>{children}</FBoxContainer>
    </Stack>
  );
}
